import { Injectable, signal } from '@angular/core';
import { HttpStatusEnum } from '@core/api';
import { DashboardApi } from '../api';
import { DashboardData } from '../interfaces';

@Injectable()
export class DashboardService {
    private readonly defaultDashboardData: DashboardData = {
        hasDefaultPaymentMethod: false,
        ordersData: {
            totalNumberOfOrders: 0,
            recentOrders: [],
        },
        expiringSamplesData: {
            totalNumberOfExpiringSamples: 0,
            expiringSamples: [],
        },
        orderResultsData: {
            totalNumberOfOrdersAndRetestsWithResults: 0,
            ordersAndRetestsWithRecentResults: [],
        },
        courierPickupDetails: {
            courierName: '',
            establishedCourierOrganization: false,
            requestCutoffTime: '',
            dropboxCutoffTime: '',
        },
    };

    readonly dashboardData = signal(this.defaultDashboardData);

    constructor(private dashboardApi: DashboardApi) {}

    async initializeDashboardData() {
        const response = await this.dashboardApi.getDashboardData();
        if (response.status === HttpStatusEnum.SUCCESS && response.data) {
            this.dashboardData.set(response.data);
        }
    }
}
